import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Col, Container, Row } from "reactstrap";
import SVG from "../SVG";
import { PropsTypes } from "../../Types/CommonElements/Breadcrumbs";
import H4 from "../Headings/H4Element";

const Breadcrumbs = ({ mainTitle, parent }: PropsTypes) => {
  return (
    <Container fluid>
      <div className="page-title">
        <Row>
          <Col xs="6">
            <H4 style={{ color: "#121F39" }}>{mainTitle}</H4>
          </Col>
          <Col xs="6">
            <Breadcrumb>
              <BreadcrumbItem>
                <Link to={`/dashboard `}>
                  <SVG iconId="stroke-home" className="stroke-icon" />
                </Link>
              </BreadcrumbItem>
              {parent && (
                <BreadcrumbItem style={{ color: "#121F39" }}>
                  {parent}
                </BreadcrumbItem>
              )}
              <BreadcrumbItem
                className="active"
                style={{ color: "#121F39", fontWeight: "500" }}
              >
                {mainTitle}
              </BreadcrumbItem>
            </Breadcrumb>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default Breadcrumbs;
